import { IOrderGroupRepository } from '@/coreInfrastructureModule/interfaces/IOrderGroupRepository';
import { ICombinedOrderState } from '../pages/useInventoryStore/type';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ICombinedOrderWithBusiness } from '../domains/entities/InventoryOrder';
import { CombinedOrderAdapter } from '../adapters/CombinedOrderAdapter';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * まとめ発注を作成する関数
 */
export class CreateCombinedOrderUseCase {
  private repository: IOrderGroupRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderGroupRepository) {
    this.repository = repository;
  }

  /**
   * まとめ発注を登録する
   * @param request - リクエスト
   */
  public execute = async (request: ICombinedOrderState): Promise<INetworkResult<ICombinedOrderWithBusiness[], IError>> => {
    const adaptedRequest = CombinedOrderAdapter.adaptCombinedOrderRequest(request);
    try {
      const networkResult = await this.repository.createBulkOrder(adaptedRequest);
      switch (networkResult.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: CombinedOrderAdapter.adaptCombinedOrderResponse(networkResult.status.data.data),
            },
          };
        case 'error':
          return {
            status: {
              type: 'error',
              error: networkResult.status.error,
            },
          };
        default:
          throw new Error();
      }
    } catch (e) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: -1,
            code: 'unknown',
            message: '想定外のエラー',
          },
        },
      };
    }
  };
}
